import { BaseService } from "./base.service";
export class UniversityTemplateCriteriaCategoryService extends BaseService {
  constructor() {
    super("university-template-criterion-categories");
  }
}
